/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value06: "",
    value06a: "",
    value07: "",
    value08: "",
    value09: "",
    value10: "",
    value11: "",
    value12: "",
    value13: "",
    value14: "",
    value15a: "",
    value15b: "",
    value16: "",
    value17a: "",
    value17: "",
    value18: "",
    value19a: "",
    value19: "",
    value20: "",
    value21: "",
    value22: "",
    value22a: "",
    value23: "",
    value24: "",
    value25: "",
    value26: "",
    value27: "",
    value28: "",
  },
];

export default function TaxPersonalTable02({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value06: "",
      value06a: "",
      value07: "",
      value08: "",
      value09: false,
      value10: false,
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15a: "",
      value15b: "",
      value16: "",
      value17a: "",
      value17: "",
      value18: "",
      value19a: "",
      value19: "",
      value20: "",
      value21: "",
      value22: "",
      value22a: "",
      value23: "",
      value24: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center" }}>
                STT
                <div className="button-action">
                  <button onClick={handleAdd} type="button">
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Hợp đồng / kỳ thanh toán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Họ tên bên thuê tài sản (*)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế bên thuê tài sản
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Loại tài sản (*)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số hợp đồng (*)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Ngày hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mục đích sử dụng tài sản thuê (*)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Bên thuê có đầu tư xây dựng cơ bản
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Địa chỉ bất động sản cho thuê
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Diện tích sản cho thuê (*)
              </Td>
              <Td rowSpan={1} colSpan={5} style={{ textAlign: "center" }}>
                Kỳ thanh toán
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tháng cho thuê của hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tổng giá trị hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Doanh thu bình quân tháng của hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tổng doanh thu phát sinh trong năm
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Cá nhân thuộc diện phải nộp thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Doanh thu tính thuế trong kỳ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế GTGT phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNCN phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Trạng thái hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã hợp đồng
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Bất động sản
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Động sản
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Địa chỉ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Phường/Xã
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Kỳ thanh toán ổn định (Số tháng)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Từ ngày / tháng / năm (*)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đến ngày / tháng / năm (*)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Năm tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá cho thuê 1 tháng đã bao gồm thuế (*)
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (06)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (06a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (07)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (08)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (09)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (10)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (11)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (12)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (13)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (14)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (15a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (15b)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (16)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (17a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (17)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (18)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (19a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (19)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (20)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (21)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (22)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (22a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (23)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (24)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (25)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (26)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (27)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (28)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  rowSpan={1}
                  style={{ textAlign: "center", background: "#ddeff3" }}
                >
                  {index + 1}
                  <div className="button-action delete">
                    <button onClick={() => handleDelete(item.id)} type="button">
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value06a", value: e.target.value })
                    }
                  >
                    <option value="value1">VND</option>
                    <option value="value2">USD</option>
                  </select>
                </Td>

                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value07"
                    value={item.value07}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value08"
                    value={item.value08}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <Switch
                    value={item.value09}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value09", value: e.target.checked })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <Switch
                    value={item.value10}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value10", value: e.target.checked })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <Switch
                    value={item.value14}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value14", value: e.target.checked })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value15a"
                    value={item.value15a}
                    onChange={handleChange}
                    type="text"
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value06a", value: e.target.value })
                    }
                  >
                    <option value="value1">TP.HCM</option>
                    <option value="value2">USD</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value17a"
                    value={item.value17a}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                      enableTime: false,
                    }}
                    name="value17"
                    onChange={(e) => handleChange({ id: item.id, name: "value17", value: e[0] })}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                      enableTime: false,
                    }}
                    name="value18"
                    onChange={(e) => handleChange({ id: item.id, name: "value18", value: e[0] })}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value19"
                    value={item.value19}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value20"
                    value={item.value20}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value21"
                    value={item.value21}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value22a"
                    value={item.value22a}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <Switch
                    value={item.value23}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value23", value: e.target.checked })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value24"
                    value={item.value24}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value27", value: e.target.value })
                    }
                  >
                    <option value="value1">TP.HCM</option>
                    <option value="value2">USD</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value28"
                    value={item.value28}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
            Thêm dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
